// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__hBc_t","productName":"Table_productName__V_1Bd"};